var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';



//////////////////
// WEBPACK FOOTER
// ../~/babel-runtime/~/core-js/library/modules/_user-agent.js
// module id = 385
// module chunks = 0